import { Box, Typography } from '@mui/material';
import { cloneElement } from 'react';
import { useTranslation } from 'react-i18next';

import { VendorActivationStatus } from 'entities/Vendors';
import { DynamicTooltip } from 'shared/ui/Tooltip';

import { STATUS_CONFIG } from '../lib/config/supplierStatusConfig';

interface SupplierStatusTooltipProps {
    status: VendorActivationStatus;
}

export const SupplierStatusTooltip = ({
    status,
}: SupplierStatusTooltipProps) => {
    const { t } = useTranslation();
    const config = STATUS_CONFIG[status as keyof typeof STATUS_CONFIG];

    if (!config) return null;

    const tooltipTitle = t(config.tooltipTitleKey, config.tooltipTitleDefault);

    return (
        <DynamicTooltip
            content={
                <Box>
                    {tooltipTitle && (
                        <Typography
                            variant="subtitle2"
                            sx={{
                                fontWeight: 600,
                                color: config.color,
                                marginBottom: '8px',
                            }}
                        >
                            {tooltipTitle}
                        </Typography>
                    )}
                    <Typography
                        variant="body2"
                        sx={{ lineHeight: 1.4, whiteSpace: 'pre-line' }}
                    >
                        {t(config.tooltipBodyKey, config.tooltipBodyDefault)}
                    </Typography>
                </Box>
            }
        >
            {cloneElement(config.icon, {
                sx: {
                    color: `${config.color} !important`,
                    fontSize: '1.5rem',
                    marginTop: '4px',
                },
            })}
        </DynamicTooltip>
    );
};
